import { useEffect, useState } from 'react'
import { mrbgStore, setSettingsForm } from './mrbg/mrbgRedux/index.js'

function ManageInputs(){

  const
    [formID,setFormID] = useState(undefined),
    [activeForms,setActiveForms] = useState(mrbgStore.getState().activeForms),
    [formSettings,setFormSettings] = useState( {} );

  useEffect(()=>{
    if( activeForms?.includes('apoResFrame') )
      setFormID('apoRes');
    else if( activeForms?.includes('apoResUpdFrame') )
      setFormID('apoResUpd');
    else if( activeForms?.includes('bilPayFrame') )
      setFormID('bilPay');
    else if( activeForms?.includes('FUAFrame') )
      setFormID('FUA');
    else if( activeForms.includes('disFrame') )
      setFormID('dis');
    else if( activeForms.includes('comRulFrame') )
      setFormID('comRul');
    else
      setFormID(undefined)
  },[activeForms])
  useEffect(() => {
    if( formID ){
      setFormSettings(mrbgStore.getState().formsSettings[formID]);
      const unsubscribe = mrbgStore.subscribe(()=>{
        setFormSettings(mrbgStore.getState().formsSettings[formID])
      })
      return () =>unsubscribe();
    }
  }, [formID]);
  useEffect(()=>{
    if( !formSettings?.STV )
      return;

    var fs = {...formSettings};
    if( formID==='FUA' ){
      formSettings.STV.outcomeStatus && formSettings.STV.outcomeStatus[0]==='فیکس'?
        mrbgStore.dispatch( setSettingsForm({[formID]:{...fs,disabled:[...fs.disabled].removeItem('amount')}}) ):
        mrbgStore.dispatch( setSettingsForm({[formID]:{...fs,disabled:[...new Set([...fs.disabled,'amount'])]}}) )
    }
    else if( formID==='dis' ){
      let
        type =
          formSettings.STV.type?
            formSettings.STV.type[0]:
            undefined,
        disabled = [];

      if( !type || type==='thresholdAmount' )
        disabled.push('minPaymentPercent');

      if( type!=='thresholdAmount' )
        disabled.push('thresholdAmount');

      if( type!=='job' )
        disabled.push('job');

      if( type!=='gender' )
        disabled.push('gender');

      mrbgStore.dispatch( setSettingsForm({[formID]:{...fs,disabled:[...new Set(disabled)]}}) );
    }
    else if( formID==='comRul' ){
      let
        type =
          formSettings.STV.type?
            formSettings.STV.type[0]:
            undefined;

      if( !type )
        mrbgStore.dispatch( setSettingsForm({[formID]:{...fs,disabled:['revenueThreshold','cap']}}) )
      else
        type === 'معرف'?
          mrbgStore.dispatch( setSettingsForm({[formID]:{...fs,disabled:['revenueThreshold']}}) ):
          mrbgStore.dispatch( setSettingsForm({[formID]:{...fs,disabled:['cap']}}) );
    }
    else if( formID==='bilPay' ){
      var len = formSettings?.partsLen?.payInfo?.currentR || 0;
      for( let i=0; i<len; i++ ){
        if(formSettings.STV[`paidType[${i}]`] && formSettings.STV[`paidType[${i}]`][0]==='پرداخت از ولت' )
          mrbgStore.dispatch( setSettingsForm({[formID]:{...fs,disabled:[...new Set([...fs.disabled,`funID[${i}]`])]}}) );
        else if( fs.disabled.includes(`funID[${i}]`) )
          mrbgStore.dispatch( setSettingsForm({[formID]:{...fs,disabled:[...fs.disabled].removeItem(`funID[${i}]`)}}) );
      }
    }
    else{
      if( formSettings.STV.paidType && ['کارت به کارت','پرداخت از ولت'].includes(formSettings.STV?.paidType[0]) )
        mrbgStore.dispatch( setSettingsForm({[formID]:{...fs,disabled:[...new Set([...fs.disabled,`funID`])]}}) );
      else if( fs.disabled.includes(`funID`) )
        mrbgStore.dispatch( setSettingsForm({[formID]:{...fs,disabled:[...fs.disabled].removeItem(`funID`)}}) );
    }
  },[formID,formSettings?.STV])
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setActiveForms( mrbgStore.getState().activeForms );
    })
    return () =>unsubscribe();
  },[]);

  return '';
}
export default ManageInputs;